export const FORM_BUILDER_FIELDS_NAME = {
  name: "name",
  site: "site",
};
